import { render, staticRenderFns } from "./SalesHandle.vue?vue&type=template&id=19836ea8&scoped=true&"
import script from "./SalesHandle.vue?vue&type=script&lang=js&"
export * from "./SalesHandle.vue?vue&type=script&lang=js&"
import style0 from "./SalesHandle.vue?vue&type=style&index=0&id=19836ea8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19836ea8",
  null
  
)

export default component.exports